import { Route, Routes } from "react-router-dom";
import LandingPage from "pages/LandingPage";
import LandingPage1 from "pages/LandingPage1";
import LandingPage2 from "pages/LandingPage2";
import ProjectPage from "pages/ProjectPage";
import ProjectPage1 from "pages/ProjectPage1";
import ProjectPage2 from "pages/ProjectPage2";
import NotFoundPage from "pages/NotFoundPage";
import TeamPage from "pages/TeamPage";
import TeamPage1 from "pages/TeamPage1";
import TeamPage2 from "pages/TeamPage2";
import AboutUs from "pages/AboutUs";
import AboutUs2 from "pages/AboutUs2";
import Customers from "pages/Customers";
import Customers2 from "pages/Customers2";

import { DiscussProjectPage1 } from "pages/DiscussProjectPage1";
import { DiscussProjectPage2 } from "pages/DiscussProjectPage2";

import { ProjectDetailPage } from "pages/ProjectDetailPage";
import { DiscussProjectPage } from "pages/DiscussProjectPage";

import "./assets/css/styles.css";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/LandingPage1" element={<LandingPage1 />} />
        <Route path="/LandingPage2" element={<LandingPage2 />} />
        <Route path="/project" element={<ProjectPage />} />
        <Route path="/projects" element={<ProjectPage1 />} />
        <Route path="/project2" element={<ProjectPage2 />} />
        <Route exact path="/project/:id" element={<ProjectDetailPage />} />
        <Route exact path="/team" element={<TeamPage />} />
        <Route exact path="/teams" element={<TeamPage1 />} />
        <Route exact path="/team2" element={<TeamPage2 />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/aboutUs2" element={<AboutUs2 />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers2" element={<Customers2 />} />
        <Route exact path="/discuss-project" element={<DiscussProjectPage />} />
        <Route
          exact
          path="/discuss-project2"
          element={<DiscussProjectPage2 />}
        />

        <Route
          exact
          path="/discuss-project1"
          element={<DiscussProjectPage1 />}
        />

        <Route path="**" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
